import { useGetInvestmentsGainersAndLosers } from "@api";
import { prepareGainersAndLosers } from "@features/dashboard/utils";
import { DashboardGainersAndLosersData } from "@features/dashboard/components/Dashboard/DashboardGainersAndLosers/types.ts";
import { useDashboardSelectedGroupsContext } from "@features/dashboard/DashboardSelectedGroupProvider.tsx";

export const useGainersAndLosers = (
  accountIds: number[]
): {
  gainersAndLosers: DashboardGainersAndLosersData;
  isFetching: boolean;
} => {
  const { isFetching: areAccountsLoading } =
    useDashboardSelectedGroupsContext();
  const { data: gainers, isFetching: isInvestmentGainersLoading } =
    useGetInvestmentsGainersAndLosers(
      {
        mode: "gainers",
        max: 8,
        accountId: accountIds,
      },
      {
        enabled: accountIds.length > 0,
      }
    );

  const { data: losers, isFetching: isInvestmentLosersLoading } =
    useGetInvestmentsGainersAndLosers(
      {
        mode: "losers",
        max: 8,
        accountId: accountIds,
      },
      {
        enabled: accountIds.length > 0,
      }
    );

  const gainersAndLosers = prepareGainersAndLosers(
    gainers?.investments,
    losers?.investments
  );

  return {
    gainersAndLosers,
    isFetching:
      areAccountsLoading ||
      isInvestmentGainersLoading ||
      isInvestmentLosersLoading,
  };
};
